if (!customElements.get("m-featured-collection")) {
    class e extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            (this.selectors = {
                loadMoreBtn: "[data-load-more]",
                loadMoreBtnWrapper: ".m-featured-collection__button",
                productsContainer: "[data-products-container]",
                products: [".m-product-card"],
                soldNumber: ["[data-sold-number]"],
                availableNumber: ["[data-available-number]"],
                countDown: "[data-flashsale-countdown]",
                slideControls: ".m-slider-controls",
                slideContainer: ".m-mixed-layout__wrapper",
            }),
                (this.domNodes = queryDomNodes(this.selectors, this)),
                (this.buttonType = this.dataset.buttonType),
                (this.infiniteLoad = this.dataset.infiniteLoad),
                (this.enableSlider = "true" === this.dataset.enableSlider),
                (this.showPagination = "true" === this.dataset.showPagination),
                (this.showNavigation = "true" === this.dataset.showNavigation),
                (this.enableFlashsale = "true" === this.dataset.enableFlashsale),
                (this.enableCountdown = "true" === this.dataset.enableCountdown),
                (this.id = this.dataset.id),
                (this.items = this.dataset.items),
                (this.mobileDisableSlider = "true" === this.dataset.mobileDisableSlider),
                this.initByScreenSize(),
                document.addEventListener("matchMobile", () => {
                    this.initByScreenSize();
                }),
                document.addEventListener("unmatchMobile", () => {
                    this.initByScreenSize();
                }),
                this.enableFlashsale && this.initFlashSale(),
                (this.canLoad = !0),
                (this.currentPage = 1),
                (this.spinner = spinner()),
                this.enableSlider || "load" !== this.buttonType || "true" !== this.infiniteLoad || this.initInfiniteLoad(),
                this.enableSlider || "load" !== this.buttonType || this.initLoadMore(),
                MinimogTheme.config.mqlMobile &&
                    this.mobileDisableSlider &&
                    "load" === this.buttonType &&
                    "true" === this.infiniteLoad &&
                    this.initInfiniteLoad(),
                MinimogTheme.config.mqlMobile && this.mobileDisableSlider && "load" === this.buttonType && this.initLoadMore(),
                document.addEventListener("matchMobile", () => {
                    MinimogTheme.config.mqlMobile && this.mobileDisableSlider && "load" === this.buttonType && this.initLoadMore(),
                        MinimogTheme.config.mqlMobile &&
                            this.mobileDisableSlider &&
                            "load" === this.buttonType &&
                            "true" === this.infiniteLoad &&
                            this.initInfiniteLoad();
                });
        }
        initByScreenSize() {
            if (!this.enableSlider) return;
            const { slideContainer: e, slideControls: t } = queryDomNodes(this.selectors, this);
            MinimogTheme.config.mqlMobile && this.mobileDisableSlider
                ? (t && t.classList.add("m:hidden"), e && e.classList.remove("swiper-container"), this.swiper && this.swiper.destroy(!1, !0))
                : (t && t.classList.remove("m:hidden"), this.initSlider());
        }
        initSlider() {
            const { slideContainer: e } = queryDomNodes(this.selectors, this),
                t = this.querySelector(".m-slider-controls"),
                i = t && t.querySelector(".m-slider-controls__button-prev"),
                s = t && t.querySelector(".m-slider-controls__button-next"),
                o = e.querySelector(".swiper-wrapper").childElementCount;
            e && e.classList.add("swiper-container"),
                (this.slider = new MinimogLibs.Swiper(e, {
                    slidesPerView: 2,
                    showPagination: this.showPagination,
                    showNavigation: this.showNavigation,
                    loop: !this.enableFlashsale,
                    pagination: !!this.showPagination && { el: this.querySelector(".swiper-pagination"), clickable: !0 },
                    autoplay: {
                        delay: 3500,
                        pauseOnMouseEnter: true,
                        disableOnInteraction: false
                    },
                    breakpoints: {
                        768: { slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items) },
                        1024: { slidesPerView: parseInt(this.items) >= 4 ? 4 : parseInt(this.items) },
                        1280: { slidesPerView: parseInt(this.items) },
                    },
                    threshold: 2,
                    on: {
                        init: () => {
                            setTimeout(() => {
                                const e = this.querySelector(".m-image") || this.querySelector(".m-placeholder-svg");
                                if (e && t) {
                                    const o = e.clientHeight;
                                    t.style.setProperty("--offset-top", parseInt(o) / 2 + "px"),
                                        i && i.classList.remove("m:hidden"),
                                        s && s.classList.remove("m:hidden");
                                }
                            }, 200);
                        },
                        breakpoint: (e, i) => {
                            if (t) {
                                const { slidesPerView: s } = i;
                                o > s ? (t.classList.remove("m:hidden"), (e.allowTouchMove = !0)) : (t.classList.add("m:hidden"), (e.allowTouchMove = !1));
                            }
                        },
                    },
                })),
                this.slider &&
                    this.showNavigation &&
                    (i && i.addEventListener("click", () => this.slider.slidePrev()), s && s.addEventListener("click", () => this.slider.slideNext())),
                (this.swiper = e && e.swiper);
        }
        initLoadMore() {
            (this.triggerLoad = !1),
                (this.totalPages = parseInt(this.dataset.totalPages)),
                addEventDelegate({
                    context: this.container,
                    selector: this.selectors.loadMoreBtn,
                    handler: (e) => {
                        e.preventDefault(), this.handleLoadMore();
                    },
                });
        }
        initInfiniteLoad() {
            const e = this.dataset.maxPages;
            window.addEventListener("scroll", (t) => {
                (this.canLoad = this.currentPage < parseInt(e)),
                    this.canLoad &&
                        this.offsetTop + this.clientHeight - window.innerHeight < window.scrollY &&
                        !this.triggerLoad &&
                        ((this.triggerLoad = !0), this.handleLoadMore());
            });
        }
        async handleLoadMore() {
            this.currentPage++, (this.canLoad = this.currentPage < this.totalPages), this.toggleLoading(!0);
            const e = this.dataset.collectionId,
                t = await fetchCountDown(e),
                i = `${this.dataset.url}?page=${this.currentPage}&section_id=${this.id}`;
            fetchCache(i).then((e) => {
                this.toggleLoading(!1);
                const i = generateDomFromString(e).querySelector(this.selectors.productsContainer),
                    s = this.domNodes.productsContainer.childElementCount;
                let o = !1;
                if (
                    (i &&
                        Array.from(i.childNodes).forEach((e) => {
                            this.domNodes.productsContainer.appendChild(e);
                            const t = setInterval(() => {
                                this.domNodes.productsContainer.childElementCount > s && (clearInterval(t), (o = !0));
                            }, 50);
                        }),
                    this.enableFlashsale && t.ok && t.payload && t.payload.length)
                ) {
                    const { expires_date: e } = t.payload[0];
                    this.expires_date = e;
                    const i = setInterval(() => {
                        if (o) {
                            clearInterval(i);
                            this.domNodes.productsContainer.querySelectorAll(".m-product-card").forEach((e) => {
                                const i = e.querySelector(".m-product-card__content");
                                if (!e.querySelector(".m-product-sale-progress")) {
                                    let s;
                                    e.dataset.soldNumber && (s = e.dataset.soldNumber);
                                    const o = saleProgress(t.payload[0], e.dataset.productId, s),
                                        a = generateDomFromString(o);
                                    i.appendChild(a);
                                }
                            });
                        }
                    }, 50);
                }
                (this.triggerLoad = !1), this.canLoad || (this.domNodes.loadMoreBtn && this.domNodes.loadMoreBtn.classList.add("m:hidden"));
            });
        }
        toggleLoading(e) {
            this.domNodes.loadMoreBtn &&
                (e ? this.domNodes.loadMoreBtn.classList.add("m-spinner-loading") : this.domNodes.loadMoreBtn.classList.remove("m-spinner-loading"));
        }
        async initFlashSale() {
            const e = this.dataset.collectionId,
                t = await fetchCountDown(e);
            if (t.ok && t.payload && t.payload.length) {
                const { expires_date: e } = t.payload[0];
                (this.expires_date = e),
                    this.domNodes.products.forEach((e) => {
                        const i = e.querySelector(".m-product-card__content"),
                            s = e.querySelector(".m-product-sale-progress");
                        let o;
                        e.dataset.soldNumber && (o = e.dataset.soldNumber);
                        const a = saleProgress(t.payload[0], e.dataset.productId, o),
                            n = generateDomFromString(a);
                        s || i.appendChild(n);
                    }),
                    this.initCountDown();
            }
        }
        initCountDown() {
            const e = new Date(this.expires_date).getTime();
            this.countDownTimer = new CountdownTimer(this.domNodes.countDown, Date.now(), e, { loop: !0 });
        }
    }
    customElements.define("m-featured-collection", e);
}
